import * as React from 'react';

const Tag16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m7.38 2.5 5.93 5.93-4.88 4.88L2.5 7.38V3.1c0-.33.27-.6.6-.6h4.28ZM7.57 1H3.1A2.1 2.1 0 0 0 1 3.1v4.47c0 .28.11.55.31.74l6.38 6.38c.21.21.47.31.74.31s.54-.1.74-.31l5.52-5.52c.41-.41.41-1.07 0-1.48L8.31 1.31c-.2-.2-.46-.31-.74-.31Z"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M5 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z" }));
Tag16.Size = 16;
Tag16.Title = "Tag";

export { Tag16 as default };
